import script from "./RoleRequiredCalendarCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredCalendarCell.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredCalendarCell.vue?vue&type=style&index=0&id=df52c8c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df52c8c2"]])

export default __exports__